import { combineReducers } from 'redux';

import item from './item';
import condition from './condition';

export default combineReducers({
    condition: condition,
    item:item
})
